import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import router from "../router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
    isAuthError: false,
    authErrorMessage: "",
    dashboardData: {}
  },
  getters: {
    currentUser(state) {
      return state.currentUser;
    },
    authError(state) {
      return state.authErrorMessage;
    }
  },
  mutations: {
    setUser(state, data) {
      state.currentUser = data;
      state.isAuthError = false;
      state.authErrorMessage = "";
    },
    setAuthError(state, data) {
      state.isAuthError = true;
      state.authErrorMessage = data;
    }
  },
  actions: {
    /*
      User Actions

    */
    getDashboardData(context, data) {
      // make call for user data
    },

    /*
    Stripe Actions
    */
    dispatchCheckout(context, data) {
      console.log("in vuex checkout");
      console.log(data);
      // TODO- Integration with backend Stripe
    },

    /*
    Auth Actions
    */
    /*
    dispatchPreregister

    */
    dispatchPreregister(context, email) {
      // add to mailerlite email for preregister
      // reroute
    },
    /*
      Opt In Action-
        Calls Firebase Email - email confirmation
        Redirects user to Info Page
    */
    dispatchOptIn(context, email) {
      var actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for this
        // URL must be whitelisted in the Firebase Console.
        url: "https://localhost:8000/almost-there",
        // This must be true.
        handleCodeInApp: true
      };
      console.log(email);
      firebase
        .auth()
        .sendSignInLinkToEmail(email, actionCodeSettings)
        .then(resp => console.log(resp));
    },
    /*
      Email Password Sign Up Action -
        Calls Firebase User and Password Signup
        Redirects to login Page
    */
    dispatchEmailPasswordSignUp(context, data) {
      console.log(data.password);
      firebase
        .auth()
        .createUserWithEmailAndPassword(data.email, data.password)
        .then(function(response) {
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    /*
      Email Password Login-
        Calls Firebase user and password login
    */
    async dispatchPasswordLogin(context, data) {
      firebase
        .auth()
        .signInWithEmailAndPassword(data.email, data.password)
        .then(function(response) {
          context.commit("setUser", response);
          router.push("/");
        })
        .catch(function(error) {
          console.log(error);
          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode === "auth/wrong-password") {
            console.log(errorMessage);
            context.commit("setAuthError", "Wrong password");
          } else {
            context.commit("setAuthError", error.message);
          }
        });
    },
    /*
      SSO SignIn-
    */
    dispatchSSO(context, data) {
      var provider;
      // TODO- Add Scopes
      switch (data) {
        case "github":
          provider = new firebase.auth.GithubAuthProvider();
          provider.addScope("repo");
          break;
        case "facebook":
          provider = new firebase.auth.FacebookAuthProvider();
          break;
        case "google":
          provider = new firebase.auth.GoogleAuthProvider();
          break;

        default:
          break;
      }

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          // This gives you a the Twitter OAuth 1.0 Access Token and Secret.
          // You can use these server side with your app's credentials to access the Twitter API.
          var token = result.credential.accessToken;
          var secret = result.credential.secret;
          // The signed-in user info.
          var user = result.user;
          context.commit("setUser", user);
          router.push("/");

          // ...
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          console.log("error");
          console.log(error);
          if (error.code === "auth/account-exists-with-different-credential") {
            // link accounts
            firebase
              .auth()
              .fetchSignInMethodsForEmail(error.email)
              .then(providers => {
                console.log(providers);
                //https://firebase.google.com/docs/auth/web/google-signin
              });
            //user.linkWithCredential(error.credential)
          }
          // ...
        });
    },
    /*
     * Signout-
     */
    dispatchSignout(context) {
      context.commit("setUser", null);
      firebase
        .auth()
        .signOut()
        .then(function() {})
        .catch(function(error) {});
      router.push("/login");
    }
  }
});
